import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export function UnsubscribePage() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading" });
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    api.post("/price-alerts/unsubscribe", { token: params.get("token") || "" })
      .then((r) => setState({ status: "done", product: r.data.product }))
      .catch(() => setState({ status: "error" }));
  }, [params]);
  return (
    <div data-testid="unsubscribe-page" className="max-w-xl mx-auto px-6 py-24 text-center">
      {state.status === "loading" && <p className="text-[#5C5A56]">One moment…</p>}
      {state.status === "done" && (
        <>
          <h1 className="font-display text-3xl text-[#2C2B29]">You're unsubscribed.</h1>
          <p className="text-[#5C5A56] mt-3">We won't send more price alerts{state.product ? ` for ${state.product}` : ""}.</p>
        </>
      )}
      {state.status === "error" && <p className="text-[#5C5A56]">This link is invalid or has already been used.</p>}
      <Link to="/" className="hh-link text-sm mt-6 inline-block">Back to HomeHearth →</Link>
    </div>
  );
}
